import { Ferramenta, ModalidadeParticipante } from 'enum';
import { AssociadoType } from 'models/associado';
import {
  DadosNaoAssociado,
  Evento,
  ParticipanteNaoAssociado,
} from 'models/naoAssociado';
import { Dispatch } from 'react';
import { RegistroReducerType } from './RegistroContext';

interface GenericType<Type = string, Payload = any> {
  type: Type;
  payload: Payload;
}

export type RegistroActionType =
  | GenericType<'setHibrido', boolean>
  | GenericType<'setFerramenta', Ferramenta>
  | GenericType<'setDados', Partial<AssociadoType>>
  | GenericType<'setDadosNaoAssociado', Partial<DadosNaoAssociado>>
  | GenericType<'setLoading', boolean>
  | GenericType<'setNaoAssociado', boolean>
  | GenericType<'setEventoSistemico', boolean>
  | GenericType<'setModalidade', ModalidadeParticipante | undefined>
  | GenericType<'setIdEvento', number>
  | GenericType<'setEvento', Evento>
  | GenericType<'setFlow', boolean>
  | GenericType<'clear', never>;

export interface RegistroContextType {
  state: RegistroReducerType;
  dispatch: Dispatch<RegistroActionType>;
  searchCPF: (
    cpf: string,
    recaptchaV2Token: string
  ) => Promise<void | AssociadoType>;
  changeAccountAttendance: (value: boolean, id: string) => void;
  confirmAssociatePresence: (recaptchaV2Token: string) => Promise<any>;
  criarParticipanteNaoAssociado: (
    participante: ParticipanteNaoAssociado,
    recaptchaV2Token: string
  ) => Promise<any>;
  isRecaptchaV2: boolean;
}

export default function RegistroReducer(
  state: RegistroReducerType,
  action: RegistroActionType
): RegistroReducerType {
  const { type, payload } = action;
  switch (type) {
    case 'setHibrido':
      return { ...state, hibrido: payload };
    case 'setFerramenta':
      return { ...state, ferramenta: payload };
    case 'setDados':
      return {
        ...state,
        dados: { ...state.dados, ...(payload as AssociadoType) },
      };
    case 'setLoading':
      return { ...state, loading: payload };
    case 'setNaoAssociado':
      return { ...state, naoAssociado: payload };
    case 'setEventoSistemico':
      return { ...state, eventoSistemico: payload };
    case 'setModalidade':
      return { ...state, modalidade: payload };
    case 'setIdEvento':
      return { ...state, idEvento: payload };
    case 'setEvento':
      return { ...state, evento: payload };
    case 'setFlow':
      return { ...state, flow: payload };
    case 'setDadosNaoAssociado':
      return {
        ...state,
        dadosNaoAssociado: {
          ...(state.dadosNaoAssociado ?? {}),
          ...(payload as DadosNaoAssociado),
        },
      };
    case 'clear':
      return {
        ...state,
        modalidade: undefined,
        dados: undefined,
        naoAssociado: false,
      };
    default:
      return { ...state };
  }
}
